import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { gridStyle } from "../Grid/Grid.css";
import { transition } from "../../utils/transition";
import { transitionDurations } from "../../theme/transitionDurations";

export const DEFAULT_CLOSED_CARD_WIDTH = 340;
export const CLOSED_CARD_HEIGHT = 298;

export const containerStyle = recipe({
  base: {
    maxWidth: `calc(100vw - ${theme.spacings.m})`,
    scrollSnapAlign: "center",
    transition: transition({
      property: "width",
      duration: `${transitionDurations.m}s`,
    }),
    vars: {
      "--carousel-child-width": "auto",
    },
    padding: `${rem(2)} 0`,
    selectors: {
      [`${gridStyle} &`]: {
        width: "100% !important",
        gridRow: "span 2",
      },
    },
  },
});

export const mainContentStyle = style({
  minHeight: rem(CLOSED_CARD_HEIGHT),
  height: rem(CLOSED_CARD_HEIGHT),
  flexGrow: 1,
});

export const heightAnimationStyle = style({
  overflow: "hidden",
  position: "relative",
});

export const collapsedContentStyle = style({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
});

export const cardStyle = style({
  outlineOffset: "-1px",
});

export const headerStyle = recipe({
  base: {
    overflow: "hidden",
  },
  variants: {
    padding: {
      true: {
        padding: theme.spacings.m,
      },
    },
  },
});

export const cardContentStyle = style({
  gap: 0,
});

export const contentStyle = recipe({
  base: {
    containerName: "container",
    containerType: "inline-size",
  },
  variants: {
    padding: {
      true: {
        padding: theme.spacings.m,
        paddingTop: 0,
      },
    },
  },
});

export const footerStyle = recipe({
  base: {
    flexGrow: 1,
  },
  variants: {
    padding: {
      true: {
        padding: theme.spacings.m,
      },
    },
  },
});

export const progressBarStyle = style({
  position: "absolute",
  top: 0,
  left: theme.spacings.xs,
  right: theme.spacings.xs,
  width: `calc(100% - ${theme.spacings.xs} * 2)`,
  zIndex: 3,
  borderBottomLeftRadius: theme.borderRadiuses.xs,
  borderBottomRightRadius: theme.borderRadiuses.xs,
  overflow: "hidden",
});

export const loadingContentStyle = recipe({
  base: {
    transition: transition("opacity"),
  },
  variants: {
    loading: {
      true: {
        opacity: 0.5,
        pointerEvents: "none",
      },
    },
  },
});

export const subtitleStyle = style({
  maxWidth: rem(DEFAULT_CLOSED_CARD_WIDTH - 64),
});

export const expandedSubtitleStyle = style({
  width: `calc(var(--container-width) - ${theme.spacings.m} * 6)`,
  overflow: "hidden",
});
